import { motion } from 'framer-motion'
import SearchOffIcon from '@mui/icons-material/SearchOff'
import { Button } from '@mui/material'
import { colors } from '../styles/theme'

const EmptyState = ({
  title = 'No results found',
  message = 'Try adjusting your search or filters',
  actionLabel,
  onAction
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col items-center justify-center min-h-[400px] space-y-4 text-center"
    >
      <motion.div
        animate={{
          y: [0, -10, 0],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      >
        <SearchOffIcon sx={{ fontSize: 80, color: colors.textMuted }} />
      </motion.div>
      <h3 className="text-2xl font-bold text-gray-300">{title}</h3>
      <p className="text-gray-400 max-w-md">{message}</p>
      {actionLabel && onAction && (
        <Button
          onClick={onAction}
          variant="outlined"
          sx={{
            borderColor: colors.info,
            color: colors.info,
            mt: 2,
            '&:hover': {
              borderColor: colors.info,
              backgroundColor: 'rgba(var(--color-accent-info-rgb), 0.1)',
            },
          }}
        >
          {actionLabel}
        </Button>
      )}
    </motion.div>
  )
}

export default EmptyState
